import { lazy, Suspense } from "react";
import { Output } from "valibot";

import LoadingPlaceholder from "components/LoadingPlaceholder";
import { ConfigurationFieldTypeSchema } from "components/SonicBot/schemas";
import { LocaleSchema } from "shared/schemas";

import { ChatUserDataElement } from "../types";
import { getInputType } from "./functions";

const PhoneInput = lazy(() => import("react-phone-input-2"));

type Props = {
  id: string;
  type: Output<typeof ConfigurationFieldTypeSchema>;
  value: string;
  generationLanguage: Output<typeof LocaleSchema>;
  setInputValues: React.Dispatch<React.SetStateAction<ChatUserDataElement[]>>;
  isRequired: boolean;
  isDeleted: boolean;
  placeholder?: string;
};

function InputComponent(props: Props) {
  const {
    id,
    type,
    value,
    generationLanguage,
    setInputValues,
    isRequired,
    isDeleted,
    placeholder,
  } = props;

  if (isDeleted) {
    return null;
  }

  const inputType = getInputType(type);

  if (type === "phone_number") {
    return (
      <Suspense
        fallback={
          <LoadingPlaceholder generationLanguage={generationLanguage} />
        }
      >
        <PhoneInput
          inputProps={{
            required: isRequired,
            className: "!pl-12",
          }}
          containerClass="label"
          specialLabel=""
          value={value}
          placeholder={placeholder}
          onChange={(value, data, event, formattedValue) => {
            setInputValues(oldVal =>
              oldVal.map(item => {
                if (item.id === id) {
                  return { ...item, value: formattedValue };
                }
                return item;
              }),
            );
          }}
        />
      </Suspense>
    );
  }

  return (
    <input
      required={isRequired}
      value={value}
      type={inputType}
      placeholder={placeholder ?? ""}
      onChange={e => {
        setInputValues(oldVal =>
          oldVal.map(item => {
            if (item.id === id) {
              return { ...item, value: e.target.value };
            }
            return item;
          }),
        );
      }}
    />
  );
}

export default InputComponent;
